import * as React from "react";
const SvgExpand = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.5407 3.13505V1.33325H14.6668V7.45938H12.865V4.40914L4.40938 12.8648L7.45962 12.8648V14.6666H1.3335V8.54046H3.1353L3.1353 11.5907L11.591 3.13505H8.5407Z", fill: "currentColor" }));
export default SvgExpand;
